module.exports = __webpack_public_path__ + "static/media/search.6b466453.svg";